import React from 'react';
import './LoadingPopup.css';
import { FaShieldAlt } from 'react-icons/fa';

const LoadingPopup = ({ visible, message = "Just a moment..." }) => {
  if (!visible) return null;

  return (
    <div className="loading-popup-overlay">
      <div className="loading-popup fancy">
        <div className="dots-loader">
          <span></span><span></span><span></span>
        </div>
        <p>{message}</p>
        <div className="secure-note">
          <FaShieldAlt className="secure-icon" />
          <span>PuppySpot is committed to protecting your payment information</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingPopup;
